import { Navigate } from 'react-router-dom';

import { useCustomer } from './CustomerProvider';

export const RedirectToAccount: React.FC = () => {
  const { customer } = useCustomer();

  return <Navigate to={`/checking/accounts/${customer.account.id}`} />;
};

export default RedirectToAccount;
